import {GET_PRODUCT_QUESTION_LIST,CLEAR_PRODUCT_QUESTION_LIST} from "../../constants/product-questions/getProductQuestionConst"

const initialState={
    productQuestionList:[],
    totalproductQuestionCount:0,
    loadedProductQuestionCount:0,
    productQuestionListPage:0,
    isIdentityRequired:false
}

export default function productQuestionListReducer(state=initialState,action){
    switch (action.type) {
        case GET_PRODUCT_QUESTION_LIST:
          const temp=(state?.productQuestionList).concat(action?.payload?.questions)
          const newQuestions = action?.payload?.questions || [];
          const mergedQuestions = [...state.productQuestionList, ...newQuestions];
        
          // Remove duplicates by question ID (or any unique key)
          const uniqueQuestions = mergedQuestions.filter(
            (item, index, self) =>
              index === self.findIndex((q) => q.id === item.id)
          );
            return{
                ...state,
                productQuestionList:uniqueQuestions,
                totalproductQuestionCount:action?.payload?.totalCount,
                productQuestionListPage:state?.productQuestionListPage + 1,
                loadedProductQuestionCount:temp?.length,
                isIdentityRequired:action?.payload?.isIdentityRequired
            }
            
          case  CLEAR_PRODUCT_QUESTION_LIST :
           return{
              ...state,
              productQuestionList:[],
              totalproductQuestionCount:0,
              loadedProductQuestionCount:0,
              productQuestionListPage:0
           }
        default:
            return state;
    }
}